import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ThemeContext = createContext(null);

export const THEMES = [
  {
    key: "warm",
    name: "Warm Coral",
    tagline: "Warm & adventurous — ties to the logo",
    swatch: ["#FF6B4A", "#F0A830", "#1C1917"],
  },
  {
    key: "ocean",
    name: "Ocean Blue",
    tagline: "Cool & premium — the original look",
    swatch: ["#2563EB", "#38BDF8", "#060A16"],
  },
];

const CACHE_KEY = "fc_theme_cache";

const apply = (key) => {
  document.documentElement.dataset.theme = key === "ocean" ? "ocean" : "warm";
};

// Apply cached theme immediately (avoids flash) before backend responds.
if (typeof document !== "undefined") {
  const cached = localStorage.getItem(CACHE_KEY);
  apply(cached === "ocean" ? "ocean" : "warm");
}

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => localStorage.getItem(CACHE_KEY) || "warm");

  // Global theme comes from backend settings (applies for ALL visitors).
  useEffect(() => {
    api
      .get("/settings")
      .then((res) => {
        const t = res.data?.theme === "ocean" ? "ocean" : "warm";
        setThemeState(t);
        localStorage.setItem(CACHE_KEY, t);
        apply(t);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    apply(theme);
  }, [theme]);

  // Admin-only: persist globally via backend.
  const setTheme = async (key) => {
    const next = key === "ocean" ? "ocean" : "warm";
    setThemeState(next);
    localStorage.setItem(CACHE_KEY, next);
    try {
      await api.put("/settings/theme", { theme: next });
    } catch (e) {
      // non-admins can't change; revert handled by next load
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
